import React, { useEffect, useRef, useState } from 'react'
import EventForm from './EventForm'
import { Form } from 'components/UIComponents/FormStyles'
import Header from './Header'

import {
  MainWrapper,
  SectionWrapper,
  Spinner,
  Wrapper,
} from './EventForm/style'
import {
  eventCreation,
  getEventByEventID,
  editEvent,
} from 'modules/Events/actions'

import { useDispatch } from 'react-redux'
import PreviewDrawer from '../Preview/Partials/Drawer/PreviewDrawer'
import {  useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import { uploadFile } from 'modules/Drive/actions'
import SuccessMessage from 'utils/SuccessMessage'


const NewEvent = ({
  getDegreeData,
  degreeList,
  selectedType,
  setSelectedType,

  degreeListData,
  key,
  id,
  getSpecialisationList,
}) => {
  const params = useParams()
  const navigate = useNavigate()

  const [form] = Form.useForm()
  const [save, setSave] = useState(false)
  const [isFieldsMandatory, setIsFieldsMandatory] = useState(false)
  const [isDrawerVisible, setIsDrawerVisible] = useState(false)
  const [previewData, setPreviewData] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [initialLoading, setInitialLoading] = useState(true)
  const [eventStatus, setEventStatus] = useState(2)
  const [qualificationData, setQualificationData] = useState([])
  const [selectedData, setSelectedData] = useState([])
  const [speakerFields, setSpeakerFields] = useState([
    { name: '', link: '' },
  ])
  const [files, setFiles] = useState([])
  const [adjustBanner, setAdjustBanner] = useState(false)
  const [cropImage, setCropImage] = useState(null)
  const [cropper, setCropper] = useState(null)
  const cropperRef = useRef(null)

  const dispatch = useDispatch()

  const onSubmitFormData = async () => {
    try {
      const values = await form.validateFields()
      const cleanedSpeakers = values.speakers
        ? values.speakers.filter(
            speaker =>
              speaker.name &&
              speaker.name.trim() !== '' &&
              speaker.link &&
              speaker.link.trim() !== ''
          )
        : []
        const degreeDataList = payLoadFormatting(selectedData)
        const prePayDegree = degreeDataList?.map(degree => {
          const { specializations, ...rest } = degree
          return {
            ...rest,
            specialisationId: specializations,
          }
        })

      let payLoad = {
        ...values,
        speakers: cleanedSpeakers,
        eventDegreeMapping: isFieldsMandatory ? selectedData : prePayDegree,
        status: isFieldsMandatory ? 1 : 0,
        startDate: values?.startDate ? moment(values?.startDate)
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
        endDate: values?.endDate ?  moment(values?.endDate)
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : null,
        // registerStartDate: moment(values?.registerStartDate)
        //   .utc()
        //   .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        // registerEndDate: moment(values?.registerEndDate)
        //   .utc()
        //   .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        registerStartDate: values?.registerStartDate
    ? moment(values.registerStartDate)
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    : null,
  registerEndDate: values?.registerEndDate
    ? moment(values.registerEndDate)
        .utc()
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    : null,
    startTime: values?.startTime ? values?.startTime : null,
    endTime: values?.endTime ? values?.endTime : null
      }

      if (!isFieldsMandatory) {
        if (payLoad.banner === null) {
          delete payLoad.banner
        }
        if(payLoad.category === null)
        {
          delete payLoad.category
        }
        if (!isEditing) {
          let res = await dispatch(eventCreation(payLoad))
          if (res?.status > 200 && res?.status < 300) {
            SuccessMessage('Event Saved Successfully')
            navigate('/events')
          }
        } else {
          if (payLoad.banner === null) {
            delete payLoad.banner
          }
          let res = await dispatch(editEvent(payLoad, params?.eventID))
          if (res?.status > 200 && res?.status < 300) {
            SuccessMessage('Event Saved Successfully')
            navigate('/events')
          }
        }
      } else {
        delete payLoad.status
        setPreviewData(payLoad)
        cropper?.reset()
        setCropImage(null)
        setIsDrawerVisible(true)
      }
    } catch (error) {
      console.error('Validation Failed:', form, error)
    }
  }

  const payLoadFormatting = degrees => {
    return degrees?.flatMap(degree => {
      if (degree?.streams?.length === 0) {
        return {
          degreeId: degree?.degreeId,
          degreeType: degree?.type ===  "P.G.DIPLOMA"  ? "PG_DIPLOMA" : degree?.type === 'P_G_DIPLOMA' ? "PG_DIPLOMA"  : degree?.type,
          isDegreeOnly: true,
        }
      }

      return degree?.streams.map(stream => {
        return {
          degreeId: degree?.degreeId,
          degreeType: degree?.type ===  "P.G.DIPLOMA"  ? "PG_DIPLOMA" : degree?.type === 'P_G_DIPLOMA' ? "PG_DIPLOMA"  : degree?.type,
          streamId: stream?.streamId,
          specializations: stream?.specializations?.map(spec => spec?.id),
        }
      })
    })
  }
  const handleAdjustBanner = () => {
    setAdjustBanner(true)
  }

  const handleBannerClose = () => {
    setAdjustBanner(false)
  }

  const sendToApi = async blob => {
    const url = previewData?.banner?.url

    const filename = url.substring(url.lastIndexOf('/') + 1)
    let response = await dispatch(uploadFile(blob, filename, 'crop'))
    let fileObject = {
      name: filename,
      url: response,
      size: blob?.size,
      date: new Date().getTime(),
      type: blob.type,
    }

    setCropImage(fileObject)
    setAdjustBanner(false)
  }

  const handleSaveCall = async () => {
    const cropper = cropperRef.current.cropper
    const croppedCanvas = cropper.getCroppedCanvas()

    if (croppedCanvas) {
      croppedCanvas.toBlob(blob => {
        sendToApi(blob)
      }, 'image/jpeg')
    }
  }

  const handleDiscard = () => {
    cropper?.reset()
  }

  const handleDrawerClose = () => {
    setIsDrawerVisible(false)
  }

  useEffect(() => {
    if (params) {
      let path = params?.['*']
      if (path?.includes('editevent') && params?.eventID) {
        setIsEditing(true)
        fetchEventData()
      }
      if (path?.includes('newevent')) {
        setInitialLoading(false)
      }
    }
  }, [params])

  const fetchEventData = async () => {
    let data = await dispatch(getEventByEventID({ eventId: params?.eventID }))
    if (data?.status > 200 && data?.status < 300) {
      let eventData = data?.data?.data

      form.setFieldsValue({
        title: eventData?.title,
        banner: eventData?.banner?.url ? eventData?.banner : null,

        category: eventData?.category,
        allDayEvent: eventData?.allDayEvent,
        startDate: eventData?.startDate
          ? moment(eventData.startDate).utc()
          : null,
        endDate: eventData?.endDate ? moment(eventData.endDate).utc() : null,
        startTime: eventData?.startTime ? eventData.startTime : undefined,
        endTime: eventData?.endTime ? eventData.endTime : undefined,
        eventMode: eventData?.eventMode,
        location: eventData?.location,
        onlineLink: eventData?.onlineLink,
        studentfrom: eventData?.studentfrom,
        yearOfPassing: eventData?.yearOfPassing?.map(Number) || [],
        isRegister: eventData?.isRegister,
        registrationLink: eventData?.registrationLink,
        registerStartDate: eventData?.registerStartDate
          ? moment(eventData.registerStartDate).utc()
          : null,
        registerEndDate: eventData?.registerEndDate
          ? moment(eventData.registerEndDate).utc()
          : null,
          registerEndTime: eventData?.registerEndTime
          ? moment(eventData.registerEndTime, 'HH:mm')
          : undefined,
        registerAmount: eventData?.registerAmount,
        description: eventData?.description,
        eventLink: eventData?.eventLink,
        pocName: eventData?.pocName,
        pocNumber: eventData?.pocNumber,
        speakers: eventData?.speakers || [],
        documents: eventData?.documents || [],
      })
      setSpeakerFields(
        eventData?.speakers?.length > 0 ? eventData?.speakers : speakerFields
      )
      setEventStatus(eventData?.status)
      setInitialLoading(false)

      const dataList = formattingDataFromPayloadToQualification(
        eventData?.eventDegreeMapping
      )
      setSelectedData(dataList)
    }
  }

  const formattingDataFromPayloadToQualification = criteria => {
    const dataSelect = []

    Object.keys(criteria)?.forEach(degreeType => {
      const degreeData = criteria?.[degreeType]

      if (degreeData?.length > 0) {
        degreeData?.forEach(degree => {
          const existingDegreeIndex = dataSelect.findIndex(
            d => d.degreeId === degree.id
          )
          if (existingDegreeIndex > -1) {
            // Update existing degree
            const existingDegree = dataSelect[existingDegreeIndex]
            existingDegree.streams.push(
              ...degree.streams.map(stream => ({
                streamId: stream.id,
                name: stream.name,
                isSelected: true,
                specializations: stream?.specialisations?.map(spec => ({
                  name: spec.name,
                  id: spec.id,
                  status: 1,
                  streamSpecialisationId: spec.id,
                  isSelected: true,
                })),
              }))
            )
          } else {
            // Add new degree
            const transformedStreams = degree.streams?.map(stream => ({
              streamId: stream.id,
              name: stream.name,
              isSelected: true,
              specializations: stream?.specialisations?.map(spec => ({
                name: spec.name,
                id: spec.id,
                status: 1,
                streamSpecialisationId: spec.id,
                isSelected: true,
              })),
            }))

            dataSelect.push({
              degreeId: degree.id,
              shortForm: degree.shortForm,
              isSelected: true,
              streams: transformedStreams,
              type: degree.type,
            })
          }
        })
      }
    })

    return dataSelect
  }
  useEffect(() => {
    if (save) {
      onSubmitFormData()
      setSave(false)
    }
  }, [save])

  const handleSave = () => {
    setSave(true)
  }
  const filterSelected = data => {
     data
      ?.filter(degree => degree.isSelected)
      ?.map(degree => ({
        degreeId: degree.degreeId,
        shortForm: degree.shortForm,
        isSelected: degree?.isSelected,
        name: degree?.name,
        type: degree?.type,
        streams: degree.streams
          ?.filter(stream => stream.isSelected)
          ?.map(stream => ({
            streamId: stream.streamId,
            name: stream.name,
            isSelected: stream.isSelected,
            specializations:
              stream?.specializations?.length > 0
                ? stream?.specializations?.filter(
                    specialisation => specialisation.isSelected
                  )
                : [],
          })),
      }))
    return data
      ?.filter(degree => degree.isSelected)
      ?.map(degree => ({
        degreeId: degree.degreeId,
        name: degree?.name,

        shortForm: degree.shortForm,
        isSelected: degree?.isSelected,
        type: degree?.type,
        streams: degree.streams
          ?.filter(stream => stream.isSelected)
          ?.map(stream => ({
            streamId: stream.streamId,
            name: stream.name,
            isSelected: stream.isSelected,
            specializations:
              stream?.specializations?.length > 0
                ? stream?.specializations?.filter(
                    specialisation => specialisation.isSelected
                  )
                : [],
          })),
      }))
  }
  function mergeDegreeData(existingData, newData) {
    const result = [...existingData] // Clone existing data to avoid mutation
    newData?.forEach(newItem => {
      const existingDegree = result?.find(
        item => item.degreeId === newItem.degreeId
      )
      if (existingDegree) {
        if (newItem?.streams?.length > 0) {
          newItem?.streams?.forEach(newStream => {
            const existingStream = existingDegree.streams?.find(
              stream => stream.streamId === newStream.streamId
            )
            if (existingStream) {
              // Merge specializations
              //modified this code at last minute because of the qualification selection deletion
              existingStream.specializations = [
                ...new Set([
                  // ...existingStream.specializations,
                  ...newStream.specializations,
                ]),
              ]
            } else {
              // if(newStream?.streams?.length)
              // Add new stream to the existing degree
              existingDegree?.streams?.push(newStream)
            }
          })
        } else {
          existingDegree.streams = [...new Set([])]
        }
      } else {
        // Add new degree to the result
        result?.push(newItem)
      }
    })
    return result
  }


  const updateIsSelected = (field, isSelected, id, departmentId, specId) => {
    if (field == 'degree' || field == 'stream' || field == 'specialisation') {
      const updatedData = qualificationData?.map(domain => {
        // Check if id exists in the domain
        if (domain.degreeId === id && !departmentId && !specId) {
          if (isSelected) {
            return {
              ...domain,
              isSelected: isSelected,
            }
          } else {
            domain.streams.forEach(stream => {
              stream.isSelected = false
              stream?.specializations?.forEach(spec => {
                spec.isSelected = false
              })
            })
            return {
              ...domain,
              isSelected: isSelected,
            }
          }
        }
        if (domain.degreeId === id && departmentId) {
          const updatedStreams = domain.streams.map(stream => {
            // Check if id exists in the stream
            if (stream.streamId === departmentId && !specId) {
              if (isSelected) {
                if (domain.degreeId === id) {
                  domain.isSelected = true
                }
              } else {
                if (
                  domain.degreeId === id &&
                  stream.streamId === departmentId
                ) {
                  stream.isSelected = isSelected
                  //don't know why the condition is here
                  if (
                    domain?.streams?.filter(item => item.isSelected)?.length > 0
                  ) {
                    stream?.specializations?.forEach(spec => {
                      spec.isSelected = false
                    })
                  } else {
                    //if we need to uncheck degree
                    // domain.isSelected = false

                    stream?.specializations?.forEach(spec => {
                      spec.isSelected = false
                    })
                  }
                } else {
                  //console.log('code comes here if the streamid is not here')
                }
              }

              return {
                ...stream,
                isSelected: isSelected,
              }
            }

            if (
              domain.degreeId === id &&
              stream.streamId === departmentId &&
              stream.specializations &&
              id &&
              departmentId &&
              specId
            ) {
              // Check if id exists in the specialisations
              const updatedSpecialisations = stream?.specializations?.map(
                specialisation => {
                  if (specialisation.id === specId) {
                    if (isSelected) {
                      if (
                        domain.degreeId === id &&
                        departmentId == stream.streamId
                      ) {
                        domain.isSelected = true
                        stream.isSelected = true
                      }
                    }
                    return {
                      ...specialisation,
                      isSelected: isSelected,
                    }
                  }
                  return specialisation
                }
              )

              // Update stream with modified specialisations
              return {
                ...stream,
                specializations: updatedSpecialisations,
              }
            }

            return stream
          })
          // Update domain with modified streams
          return {
            ...domain,
            streams: updatedStreams,
          }
        }
        return domain
      })
      setQualificationData(updatedData)
   
      setSelectedData(prevData => {
        let selectedDegreeDataAlone = updatedData?.filter(
          item => item.degreeId == id
        )
        let isDegreeDeselected = !selectedDegreeDataAlone?.[0]?.isSelected
        let selectedDegreeData = filterSelected(selectedDegreeDataAlone)
       
          const mergeData = mergeDegreeData(prevData ?? [], selectedDegreeData)
       

        let toSelectDegree = []
        if (isDegreeDeselected) {
          toSelectDegree = mergeData
        
          toSelectDegree = mergeData?.filter(degree => degree?.degreeId !== id)
        } 
        else if( !isSelected && id && departmentId && !specId){
          toSelectDegree = mergeData?.map(degree => {
            if (degree.degreeId === id) {
              const updatedStreams = degree.streams.filter(stream => {
                // Delete the stream by filtering it out
                return stream.streamId !== departmentId;
              });
        
              return {
                ...degree,
                streams: updatedStreams,
              };
            }
            return degree;
          });
        }
        else if( !isSelected && id && departmentId && specId){
          toSelectDegree = mergeData?.map(degree => {
            if (degree.degreeId === id) {
              const updatedStreams = degree.streams.map(stream => {
                if (stream.streamId === departmentId) {
                  const updatedSpecializations = stream.specializations?.filter(
                    specialization => specialization.id !== specId
                  );
        
                  return {
                    ...stream,
                    specializations: updatedSpecializations,
                  };
                }
                return stream;
              });
        
              return {
                ...degree,
                streams: updatedStreams,
              };
            }
            return degree;
          });
        }
        else {
          toSelectDegree = mergeData
        }
       return toSelectDegree
      })
      //here something passing as undefined have to find it. (have to change the mergeData)
    } else {
      if (field == 'allDegree') {
  
        const updatedData = qualificationData?.map(domain => {
          // If isSelected is false, update streams and specializations to false
          if (!isSelected && domain?.streams?.length > 0) {
            domain.streams.forEach(stream => {
              stream.isSelected = false;
              stream.specializations?.forEach(specialization => {
                specialization.isSelected = false;
              });
            });
          }
        
          return {
            ...domain,
            isSelected: isSelected,
          };
        });
        
        setQualificationData(updatedData)
        setSelectedData(prevData => {
          let selectedDegreeData = filterSelected(updatedData)

          let mergeData
          if (!isSelected) {
            let filterIds = updatedData?.map(item => item.degreeId)

            mergeData = prevData?.filter(
              item => !filterIds?.includes(item.degreeId)
            )
          } else {
            mergeData = mergeDegreeData(prevData ?? [], selectedDegreeData)
          }
          return mergeData
        })
      } else if (field == 'allStream') {
        const updatedData = qualificationData?.map(domain => {
          if (domain?.streams?.length > 0) {
            domain?.streams?.forEach(stream => {
              stream.isSelected = isSelected
              stream?.specializations?.forEach(speciaisation => {
                speciaisation.isSelected = isSelected
                  ? speciaisation?.isSelected
                  : isSelected
              })
            })
          }
          return {
            ...domain,
            isSelected: isSelected || domain.isSelected,
          }
        })
        setQualificationData(updatedData)
        setSelectedData(prevData => {
          let selectedDegreeData = filterSelected(updatedData)

          const mergeData = mergeDegreeData(prevData ?? [], selectedDegreeData)
          return mergeData
        })
      } else {
        const updatedData = qualificationData?.map(degree => {
          let degreeSelected = degree?.isSelected
          const updatedStreams = degree.streams?.map(stream => {
            let streamSelected = stream?.isSelected
            const updatedSpecialisations = stream?.specializations?.map(
              specialisation => {
                if (specialisation) {
                  streamSelected = true
                  degreeSelected = true
                }
                return { ...specialisation, isSelected: isSelected }
              }
            )
            return {
              ...stream,
              specializations: updatedSpecialisations,
              isSelected: streamSelected,
            }
          })
          return {
            ...degree,
            streams: updatedStreams,
            isSelected: degreeSelected,
          }
        })

        setQualificationData(updatedData)
        setSelectedData(prevData => {
          let selectedDegreeData = filterSelected(updatedData)

          const mergeData = mergeDegreeData(prevData ?? [], selectedDegreeData)
          return mergeData
        })
      }
    }
  }

  return (
    <>
      <SectionWrapper column>
        {initialLoading && (
          <div>
            {' '}
            <Spinner></Spinner>
          </div>
        )}
        {!initialLoading && (
          <Form
            scrollToFirstError
            onFinish={onSubmitFormData}
            id={'eventsForm'}
            form={form}
            layout="vertical"
          >
            <Header
              onSave={handleSave}
              isFieldsMandatory={isFieldsMandatory}
              setIsFieldsMandatory={setIsFieldsMandatory}
              isEditing={isEditing}
              eventStatus={eventStatus}
            />

            <MainWrapper>
              <Wrapper>
                <EventForm
                  form={form}
                  isFieldsMandatory={isFieldsMandatory}
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  updateIsSelected={updateIsSelected}
                  setSelectedType={setSelectedType}
                  selectedType={selectedType}
                  key={key}
                  id={id}
                  setSave={setSave}
                  getDegreeData={getDegreeData}
                  degreeList={degreeList}
                  degreeListData={degreeListData}
                  getSpecialisationList={getSpecialisationList}
                  setQualificationData={setQualificationData}
                  qualificationData={qualificationData}
                  speakerFields={speakerFields}
                  setSpeakerFields={setSpeakerFields}
                  files={files}
                  setFiles={setFiles}
                  dataList={selectedData}
                />
              </Wrapper>
            </MainWrapper>
          </Form>
        )}
      </SectionWrapper>
      {isDrawerVisible && (
        <PreviewDrawer
          open={isDrawerVisible}
          onClose={handleDrawerClose}
          eventDetails={previewData}
          isEditing={isEditing}
          isPublish={true}
          adjustBanner={adjustBanner}
          cropImage={cropImage}
          cropper={cropper}
          handleAdjustBanner={handleAdjustBanner}
          handleBannerClose={handleBannerClose}
          handleSave={handleSaveCall}
          cropperRef={cropperRef}
          setCropper={setCropper}
          handleDiscard={handleDiscard}
        />
      )}
    </>
  )
}
export default NewEvent
